import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';
import { QUERY } from '@/constants/common';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';

export function useLoginUser(accessToken?: string) {
  const { replace } = useRouter();
  const { loginUser } = useAuth();
  const [isLoginInProgress, setLoginInProgress] = useState(!!accessToken);
  const { trimmedUrl } = useUrlAndHashFromPath([QUERY.access_token]);

  useEffect(() => {
    if (accessToken) {
      (async () => {
        await loginUser({ variables: { accessToken } });
        replace(trimmedUrl, undefined, { scroll: false, shallow: true });
        setLoginInProgress(false);
      })();
    }
  }, [accessToken]);

  return isLoginInProgress;
}
